import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {UserAction} from "../actions/UserAction";
import {CommonAction} from "../actions/CommonAction";
import i18n from "i18next";
import CustomLi from "./CustomLi";
import {DEFAULTS, getAsStr, getCountry, izBlank, izEmpty} from "../constants";
import femaleAvatar from "../assets/img/female-avatar.png";
import maleAvatar from "../assets/img/male-avatar.png";
import emptyAvatar from "../assets/img/empty-avatar.png";
import entityAvatar from "../assets/img/entity-avatar.png";
import TransactionTable from "./TransactionTable";
import ScoreCardModal from "./ScoreCardModal";
import SearchCardModal from "./SearchCardModal";
import {Button, Divider, message} from "antd";
import TransactionService from "../services/transaction.service";
import AuthService from "../services/auth.service";

class CustomerProfileCard extends Component {

    constructor(props) {
        super(props)

        const customerRiskLevels = this.props.common.customerRiskLevels

        this.state = {
            customerRiskLevels: customerRiskLevels,
            testing: false
        }
    }

    getCustomerRiskLevel(riskLevel) {
        const customerRiskLevels = this.props.common.customerRiskLevels

        if (izEmpty(customerRiskLevels) || this.izNotCustomerRiskLevelExist(riskLevel)) return riskLevel;

        return customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel)[0];
    }

    getCustomerRiskLevelName(riskLevel) {
        return this.getCustomerRiskLevel(riskLevel).name
    }

    getCustomerRiskLevelOrder(riskLevel) {
        return this.getCustomerRiskLevel(riskLevel).order
    }

    getCustomerRiskLevelColor(riskLevel) {
        const order = this.getCustomerRiskLevelOrder(riskLevel);

        return DEFAULTS.customerLevelColors[order];
    }

    izNotCustomerRiskLevelExist = (riskLevel) => {
        const customerRiskLevels = this.props.common.customerRiskLevels
        if (izEmpty(customerRiskLevels)) return true;
        return izEmpty(customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel))
    }

    getCustomerRiskLevelTag(riskLevel, score) {
        const customerRiskLevels = this.props.common.customerRiskLevels

        if (izEmpty(customerRiskLevels) || this.izNotCustomerRiskLevelExist(riskLevel)) return riskLevel;

        let foundCustomerRiskLevel = customerRiskLevels.filter(customerRiskLevel => customerRiskLevel.code === riskLevel)[0]

        const customerRiskLevelColor = this.getCustomerRiskLevelColor(riskLevel);
        return <div className={"customer-risk-level customer-risk-level-" + customerRiskLevelColor} key={riskLevel}>
            {score + " / " + foundCustomerRiskLevel.name}
        </div>;
    }

    searchCardModal(customer) {
        const searchLogId = customer.searchLogId;
        const searchId = customer.searchId;

        let found = searchLogId && 0 < searchLogId && (customer.sanctionFound === true || customer.pepFound === true);

        return found
            ? <div className="mb-15 sanction-check-button"><SearchCardModal itemId={searchLogId} searchId={searchId} text={i18n.t('showDetailsForTx')} danger/>
            </div>
            : <div className="mb-15 sanction-check-button"><span>{i18n.t('showDetailsClean')}</span></div>;
    }

    txPushTest = (customerNo) => {
        this.setState({testing: true});

        TransactionService.pushTest(customerNo)
            .then(
                response => {
                    this.setState({testing: false});
                    message.success(i18n.t('success'));
                },
                error => {
                    this.setState({testing: false});
                    message.error(i18n.t('global_error'));
                }
            )
    }

    render() {
        const {testing} = this.state;
        const {customer, scores, txItems} = this.props;

        const score = customer.score;
        const riskLevel = customer.riskLevel;

        const customerNo = customer.customerNo;
        const fullName = customer.fullName;
        const gender = customer.gender;
        const isIndividual = customer.type !== "E";
        let avatar = isIndividual
            ?
            gender === "F"
                ? femaleAvatar
                : (gender === "M" ? maleAvatar : emptyAvatar)
            :
            entityAvatar

        const maritalStatus = getAsStr(customer.maritalStatus);
        const hideMaritalStatus = izBlank(maritalStatus) || (maritalStatus !== "1" && maritalStatus !== "2");
        const age = customer.age;
        const birthdate = customer.birthdate;
        const placeOfBirth = customer.placeOfBirth;
        const address = customer.address;
        const nationality = getCountry(customer.nationality);
        const tckn = customer.tckn;
        const vkn = customer.vkn;
        const passport = customer.passport;

        const showTxPushTest = AuthService.hasRole("TX_PUSH_TEST");

        return (
            <>
                <div className="row mt-15">
                    <div className="col-sm-12 col-md-4 content-img">
                        <ul>
                            <li className="mb-5">
                                <img className="circled-img" key={"internal"} src={avatar} alt=""/>
                            </li>
                            <li className="mb-5 customer-risk-score">
                                <strong>{i18n.t('customerRiskScore')}</strong>
                            </li>
                            <li className="mb-5">
                                <ScoreCardModal
                                    customer={customer}
                                    scores={scores}
                                    txItems={txItems}
                                    riskLevelTag={this.getCustomerRiskLevelTag(riskLevel, score)}
                                />
                            </li>
                            <li>
                                <Divider dashed className="custom-divider"/>
                            </li>
                            <li className="mb-5 cp-sanction-check">
                                <strong>{i18n.t('sanctionPePCheck')}</strong>
                            </li>
                            <li className="mb-5">
                                <strong>{this.searchCardModal(customer)}</strong>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-12 col-md-8">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 customer-profile-content-detail">
                                <ul>
                                    <CustomLi addDotsToTitle={true} title={isIndividual ? i18n.t('person_name') : i18n.t('entity_name')} detail={fullName}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('tckn')} detail={tckn}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('vkn')} detail={vkn}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('customerNo')} detail={customerNo}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('passport')} detail={passport}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('age')} detail={age + ""}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('maritalStatus')}
                                              detail={i18n.t('maritalStatus_' + maritalStatus)}
                                              hide={hideMaritalStatus}/>
                                </ul>
                            </div>
                            <div className="col-sm-12 col-md-6 customer-profile-content-detail">
                                <ul>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('gender')} detail={i18n.t('gender_' + gender)}
                                              hide={isIndividual === false || !gender || gender !== "M" || gender !== "F"}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('date_of_birth')} detail={birthdate}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('place_of_birth')} detail={placeOfBirth}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('address')} detail={address}/>
                                    <CustomLi addDotsToTitle={true} title={i18n.t('nationality')} detail={nationality}/>
                                </ul>
                            </div>
                        </div>
                        {/*<div className="row justify-content-start">*/}
                        {/*    <div className="p-15">*/}
                        {/*        <strong>{i18n.t('sanctionPePCheck')}</strong>*/}
                        {/*    </div>*/}
                        {/*    <div className="p-15">*/}
                        {/*        {this.searchCardModal(customer)}*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>

                <div className="row mt-25">
                    <div className="col">

                        {/*<div className="transaction-search-result-count">*/}
                        {/*    {i18n.t('txItems')}*/}
                        {/*</div>*/}

                        <TransactionTable
                            items={txItems}
                            customerProfile
                        />

                    </div>
                </div>
                {showTxPushTest &&
                    <div className="row mt-25 justify-content-end">
                        <div className="col-2 mr-15">
                            <Button
                                className="custom-button"
                                type="primary"
                                onClick={() => this.txPushTest(customerNo)}
                                loading={testing}
                            >
                                {testing ? i18n.t('testing') : i18n.t('txPushTest')}
                            </Button>

                        </div>
                    </div>
                }
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProfileCard);